import { Button, Tooltip } from '@cian/ui-kit';
import { CallOrder16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import { DEFAULT_CALLBACK_CONTENT } from '../../../../constants/callback';
import { TCallBackButtonComponent } from '../../types';

export const CallbackButtonCollapsed: TCallBackButtonComponent = ({ size, onClick }) => {
  const { buttonText } = DEFAULT_CALLBACK_CONTENT;

  return (
    <Tooltip title={buttonText}>
      <Button onClick={onClick} beforeIcon={<CallOrder16 color="current_color" />} theme="fill_secondary" size={size} />
    </Tooltip>
  );
};
